module.exports = __webpack_public_path__ + "static/img/1-1Z5241G04YF.a3f64bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5241G04YF.png
// module id = W9Qr
// module chunks = 0